export const EXPEDITIONS_LIST = [
   {
      value: 'JNE',
      label: 'JNE',
      id: 'JNE',
      checked: true,
    },
    {
      value: 'IDEXPRESS',
      label: 'IDExpress',
      id: 'idexpress',
      checked: true,
    },
    {
      value: 'SICEPAT',
      label: 'SiCepat',
      id: 'sicepat',
      checked: true,
    },
    {
      value: 'SAP',
      label: 'SAP',
      id: 'SAP',
      checked: true,
    },
    {
      value: 'JNT',
      label: 'J&T',
      id: 'jnt',
      checked: true,
    },
    {
      value: 'LION',
      label: 'Lion Parcel',
      id: 'lion',
      checked: true,
    },
    {
      value: 'GOSEND',
      label: 'Gosend',
      id: 'gosend',
      checked: true,
    },
];

export const STATUS_ORDER = [
    { value: 'Diajukan', label: 'Order Created', id: 'dibuat', checked: true },
    { value: 'Dipacking', label: 'Packed', id: 'packing', checked: true },
    { value: 'Dikirim', label: 'Sent', id: 'kirim', checked: true },
    { value: 'Diterima', label: 'Received', id: 'Ongkir', checked: true },
    { value: 'Retur', label: 'Return', id: 'retur', checked: true },
    { value: 'Hilang', label: 'Missing', id: 'hilang', checked: true },
    { value: 'Rusak', label: 'Damaged', id: 'rusak', checked: true },
]